<app-breadcrumb></app-breadcrumb> <app-banner-rotator></app-banner-rotator>
<div *ngIf="hasPromoIframeUrl$ | async; else noUrl">
    <iframe class="promo-iframe" id="promo-iframe" frameborder="0" allowfullscreen
        [src]="promoIframeUrl$ | async"></iframe>
</div>
<ng-template #noUrl>
    <div>Učitavanje...</div>
</ng-template>